"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionKeyForPyr = exports.questionKeyForQre = void 0;
var page_status_utils_1 = require("./page-status.utils");
Object.defineProperty(exports, "questionKeyForQre", { enumerable: true, get: function () { return page_status_utils_1.questionKeyForQre; } });
Object.defineProperty(exports, "questionKeyForPyr", { enumerable: true, get: function () { return page_status_utils_1.questionKeyForPyr; } });
